import { render, staticRenderFns } from "./MapaConcentracaoVolumeContratos.vue?vue&type=template&id=4f453e5f&lang=pug"
import script from "./MapaConcentracaoVolumeContratos.vue?vue&type=script&lang=js"
export * from "./MapaConcentracaoVolumeContratos.vue?vue&type=script&lang=js"
import style0 from "./MapaConcentracaoVolumeContratos.vue?vue&type=style&index=0&id=4f453e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports